export default __webpack_public_path__ + "e841f7e1d5fcb869ccf6708923f189c3.svg";